import React from "react";
import type { LoyaltyTier, LoyaltyTierPrize } from "kadow-jetpack-model";
import KC_UIText from "../../../../designsystem/typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../../../../designsystem/ds_commons";
import { tt } from "../../../../utils/i18n/i18n";
import KC_Button, {
  KC_ButtonSize
} from "../../../../designsystem/KC_Button/KC_Button";
import TwemojiWrapper from "../../../../components/TwemojiWrapper/TwemojiWrapper";
import { isTierRewardTokens } from "../Loyalty/helper/defaultLoyaltyTiers";
import LoyaltyPrizeRewardEditor from "./component/LoyaltyPrizeRewardEditor";
import { LoyaltyRewardCardLayout } from "./component/LoyaltyRewardLayouts";

interface TierEditorCardProps {
  tier: LoyaltyTier;
  tierIndex: number;
  currentLang: "fr" | "en";
  setFieldValue: (field: string, value: unknown) => void;
  hasAdvancedCouponOptions: boolean;
  onCustomize: () => void;
  onStandard: () => void;
  onGenerateIdeas: () => void;
}

const TierEditorCard = ({
  tier,
  tierIndex,
  currentLang,
  setFieldValue,
  hasAdvancedCouponOptions,
  onCustomize,
  onStandard,
  onGenerateIdeas
}: TierEditorCardProps) => {
  const prize = isTierRewardTokens(tier.reward)
    ? null
    : (tier.reward as LoyaltyTierPrize);

  const title = (
    <KC_UIText
      weight={KC_Weights.bold}
      text={
        typeof tier.label === "object" && tier.label !== null
          ? (tier.label as { fr: string; en: string })[currentLang]
          : String(tier.label)
      }
    />
  );

  const subtitle = (
    <KC_UIText
      weight={KC_Weights.reg}
      text={
        tier.threshold === 1
          ? tt("loyalty_threshold_actions", {
              count: tier.threshold
            })
          : tt("loyalty_threshold_actions_plural", {
              count: tier.threshold
            })
      }
      className="text-secondary"
    />
  );

  const rightHeader = isTierRewardTokens(tier.reward) ? (
    <div className="d-flex flex-column align-items-center gap-2">
      <KC_UIText
        weight={KC_Weights.bold}
        text={tt("loyalty_tokens_count", { count: tier.reward })}
      />
      <span className="loyalty-token-coin">
        <TwemojiWrapper>🪙</TwemojiWrapper>
      </span>
    </div>
  ) : null;

  const primaryAction = isTierRewardTokens(tier.reward) ? (
    <KC_Button
      size={KC_ButtonSize.Large}
      isPrimary={false}
      isBlack={true}
      showIconOnTheRight={true}
      customIcon={
        <span className="loyalty-button-icon-wrap" style={{ fontSize: 20 }}>
          🎁
        </span>
      }
      text={tt("loyalty_customize_reward")}
      type="button"
      onClick={onCustomize}
      className="w-100 mt-2"
    />
  ) : null;

  return (
    <LoyaltyRewardCardLayout
      cardId={`tier-card-${tierIndex}`}
      icon={<TwemojiWrapper isBigText={true}>{tier.icon}</TwemojiWrapper>}
      title={title}
      subtitle={subtitle}
      rightHeader={rightHeader}
      primaryAction={primaryAction}
      cardClassName="loyalty-gift-tier-editor-card"
    >
      {!isTierRewardTokens(tier.reward) && prize && (
        <LoyaltyPrizeRewardEditor
          prize={prize}
          onPrizeChange={(updatedPrize) =>
            setFieldValue(`lty.tiers[${tierIndex}].reward`, updatedPrize)
          }
          hasAdvancedCouponOptions={hasAdvancedCouponOptions}
          onGenerateIdeas={onGenerateIdeas}
          onOfferStandardReward={onStandard}
          idPrefix={`lty.tiers[${tierIndex}].reward`}
        />
      )}
    </LoyaltyRewardCardLayout>
  );
};

export default TierEditorCard;
